<script type="text/jsx">
import UiButton from './UiButton.vue';

export default {
    functional: true,
    props: {
        outline: {
            type: Boolean,
            default: false,
        },
        modal: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    render(h, { props, children, data }) {
        data.class = { 'ui-secondary-btn': true, ...props, [data.class]: true };
        return <UiButton {...data}>{children}</UiButton>;
    },
};
</script>
<style lang="scss">
    @import "common/scss/palette";
    @import "common/scss/variables";
    @import "common/scss/variables/v2/buttons";

    .ui-secondary-btn {
        @apply h-10 px-5 text-size-3 leading-none text-white font-medium rounded whitespace-nowrap border-solid border-2 border-transparent;
        transition: 0.3s all ease-in-out;
        @include button-background(darken($purple, 10%), $purple);
        @include button-layering($shadow-bump, $shadow-level-2);

        &.modal, &.high {
            @apply h-12 text-size-3 leading-3;
            box-shadow: none;
        }

         &.low {
            @apply h-8 text-size-5 leading-none;
        }

        &.outline {
            @apply text-purple border-2 border-purple border-solid;
            background: none;
            box-shadow: none;

            &:not([disabled]):hover {
                @apply text-white bg-purple;
            }

            &:disabled {
                @apply border-2 border-gray border-solid;
            }
        }
        &.loading, &.loading:disabled {
            @apply border-2 border-solid text-light-gray;
            border-color: rgb(154, 106, 228);
            background-size: 100% 100%;
            background-position: 0% 100%;
            background: repeating-linear-gradient(
                    90deg,
                    rgb(154, 106, 228),
                    rgb(154, 106, 228) 8px,
                    rgb(174, 135, 233) 8px,
                    rgb(174, 135, 233) 16px);

            animation: scroll-loading-background 0.6s linear infinite;
        }

        @keyframes scroll-loading-background {
            from { background-position: 0 0; }
            to   { background-position: 32px 0; }
        }
    }
</style>
